import { gql } from '@apollo/client';

export const SEND_SMS = gql`
  mutation sendSms(
    $message: String!
    $filter: UserFilterInputType
  ) {
    sendSms(message: $message, filter: $filter)
  }
`;
